import { Check, Copy, Mail } from 'lucide-react';
import { useEffect, useState } from 'react';

// Support is by email (Ron, 2026-10-24): his inbox answers members outside the
// website. The ticket pages still exist (member ?subpage=support_tickets, admin
// ?subpage=tickets), unlinked, in case this needs undoing.
export const SUPPORT_EMAIL = 'admin@1simplecycler3.com';

function composeLinks(subject) {
  const su = encodeURIComponent(subject);
  return [
    { label: 'Open In Gmail', href: `https://mail.google.com/mail/?view=cm&fs=1&to=${SUPPORT_EMAIL}&su=${su}`, testid: 'gmail' },
    { label: 'Open In Outlook / Hotmail', href: `https://outlook.live.com/mail/0/deeplink/compose?to=${SUPPORT_EMAIL}&subject=${su}`, testid: 'outlook' },
    { label: 'Open In Yahoo Mail', href: `https://compose.mail.yahoo.com/?to=${SUPPORT_EMAIL}&subject=${su}`, testid: 'yahoo' },
    { label: 'Open My Email App', href: `mailto:${SUPPORT_EMAIL}?subject=${su}`, testid: 'mailto' },
  ];
}

const SupportSubpage = ({ me }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 1000);
    return () => clearTimeout(timer);
  }, [copied]);

  const subject = me?.username ? `1SC3 Support - ${me.username}` : '1SC3 Support';
  const links = composeLinks(subject);

  const copyAddress = async () => {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
      setCopied(true);
    } catch {
      // Clipboard blocked: the address is on screen to copy by hand.
    }
  };

  return (
    <div className="mx-auto max-w-xl" data-testid="subpage-support">
      <section className="sc-glass-strong rounded-2xl p-5 md:p-7 space-y-3">
        <div className="sc-pill">
          <span className="sc-dot" />
          Email Support
        </div>
        <h3 className="font-display font-bold text-xl md:text-2xl">
          Get in touch with <span className="sc-gold-text">administration</span>
        </h3>
        <p className="text-sm text-[var(--sc-text-dim)]">Email us from the address on your account and include your username.</p>
        <p className="flex items-center gap-2 pt-1 text-lg font-semibold break-all select-all" data-testid="support-email">
          <Mail className="w-5 h-5 shrink-0 text-[#FFC20E]" />
          {SUPPORT_EMAIL}
        </p>
        {links.map((link) => (
          <a
            key={link.testid}
            href={link.href}
            target={link.href.startsWith('mailto:') ? undefined : '_blank'}
            rel="noopener noreferrer"
            className="sc-btn-gold w-full"
            data-testid={`support-${link.testid}`}
          >
            {link.label}
          </a>
        ))}
        <button type="button" onClick={copyAddress} className="sc-btn-ghost w-full" data-testid="support-copy">
          {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          {copied ? 'Copied!' : 'Copy Email Address'}
        </button>
      </section>
    </div>
  );
};

export default SupportSubpage;
